import { AxiosRequestConfig, AxiosResponse } from 'axios';
import client from 'api/client';

export function post(payload: unknown, customConfig?: AxiosRequestConfig): Promise<AxiosResponse> {
    return client.post('/consultation', payload, customConfig);
}
